import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e931f3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobileHeader" }
const _hoisted_2 = {
  href: "https://ddusupport.dk",
  target: "_blank"
}
const _hoisted_3 = {
  key: 0,
  class: "va-dropdown__content-wrapper",
  style: {"width":"max-content","position":"absolute","right":"0","top":"38px"}
}
const _hoisted_4 = {
  class: "va-dropdown__content",
  role: "listbox",
  style: {"background":"var(--va-white)","color":"rgb(27, 26, 31)"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "va-button__content" }, "Hjem", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "va-dropdown",
  style: {"position":"relative"}
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "va-button__content" }
const _hoisted_10 = {
  class: "va-icon material-icons va-button__right-icon",
  "aria-hidden": "true",
  notranslate: "",
  style: {"color":"rgb(44, 130, 224)","font-size":"24px","height":"24px","line-height":"24px"}
}
const _hoisted_11 = {
  key: 0,
  class: "va-dropdown__content-wrapper",
  id: "uwf2btpt-lva6-mmze",
  style: {"width":"max-content","position":"absolute","right":"35px","top":"38px"}
}
const _hoisted_12 = {
  class: "va-dropdown__content",
  role: "listbox",
  style: {"background":"var(--va-white)","color":"rgb(27, 26, 31)"}
}
const _hoisted_13 = {
  key: 0,
  class: "va-dropdown",
  "aria-expanded": "true",
  "aria-controls": "zfcnto8x-1daf-1apt",
  style: {"position":"relative"}
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "va-button__content" }
const _hoisted_16 = {
  class: "va-icon material-icons va-button__right-icon",
  "aria-hidden": "true",
  style: {"color":"rgb(44, 130, 224)","font-size":"24px","height":"24px","line-height":"24px"}
}
const _hoisted_17 = {
  key: 0,
  class: "va-dropdown__content-wrapper",
  id: "zfcnto8x-1daf-1apt",
  style: {"width":"max-content","position":"absolute","left":"40px","top":"38px"}
}
const _hoisted_18 = {
  class: "va-dropdown__content",
  role: "listbox",
  style: {"background":"var(--va-white)","color":"rgb(27, 26, 31)"}
}
const _hoisted_19 = {
  key: 0,
  class: "va-dropdown",
  "aria-expanded": "true",
  "aria-controls": "ox41xy18-o3yo-jusj",
  style: {"position":"relative"}
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "va-button__content" }
const _hoisted_22 = {
  class: "va-icon material-icons va-button__right-icon",
  "aria-hidden": "true",
  notranslate: "",
  style: {"color":"rgb(44, 130, 224)","font-size":"16px","height":"16px","line-height":"16px"}
}
const _hoisted_23 = {
  key: 0,
  class: "va-dropdown__content-wrapper",
  style: {"width":"max-content","position":"absolute","left":"-13.8281px","top":"26px"}
}
const _hoisted_24 = {
  class: "va-dropdown__content",
  role: "listbox",
  style: {"background":"var(--va-white)","color":"rgb(27, 26, 31)"}
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "va-button__content" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "va-button__content" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "va-button__content" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "va-button__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_spacer = _resolveComponent("va-spacer")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_va_app_bar = _resolveComponent("va-app-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_va_app_bar, { color: "#ab0033" }, {
      default: _withCtx(() => [
        (_ctx.userLoggedIn())
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "loginButton ml-1",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.userLogout()))
            }, "Logout"))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "loginButton ml-1",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.login()))
            }, "Login")),
        _createVNode(_component_va_spacer),
        _createElementVNode("p", {
          class: "loggedInUser",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toMemberPortal()))
        }, [
          _createTextVNode(_toDisplayString('Hej ' + _ctx.getUserName()), 1),
          _createVNode(_component_va_icon, {
            class: "ml-2 mr-2",
            name: "account_circle",
            tag: "a"
          })
        ]),
        _createVNode(_component_va_spacer),
        _createVNode(_component_router_link, { to: "/kurven" }, {
          default: _withCtx(() => [
            _createVNode(_component_va_icon, {
              class: "ml-2 mr-2",
              name: "shopping_cart",
              color: "#fff"
            })
          ]),
          _: 1
        }),
        _createElementVNode("a", _hoisted_2, [
          _createVNode(_component_va_icon, {
            class: "ml-2 mr-2",
            name: "contact_support",
            color: "#fff"
          })
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("i", {
            class: "va-icon material-icons va-button__left-icon",
            "aria-hidden": "true",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openCloseMenu())),
            style: {"color":"rgb(255, 255, 255)","font-size":"24px","height":"24px","line-height":"24px","width":"28px","cursor":"pointer"}
          }, _toDisplayString(_ctx.openMenu ? 'expand_less' : 'more_horiz'), 1),
          (_ctx.openMenu)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.home())),
                    class: "va-button va-button--flat va-button--small homeBtn",
                    style: {"color":"rgb(44, 130, 224)","background":"var(--va-transparent)"}
                  }, _hoisted_6),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTopMenu(), (menu, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "va-button-dropdown va-button-dropdown--normal menu",
                      key: index
                    }, [
                      (_ctx.subMenu(menu.id).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.nestOneClick(menu.id)),
                              class: "va-button va-button--flat va-button--normal",
                              style: {"color":"rgb(44, 130, 224)","background":"var(--va-transparent)"}
                            }, [
                              _createElementVNode("div", _hoisted_9, [
                                _createTextVNode(_toDisplayString(menu.menu_titel) + " ", 1),
                                _createElementVNode("i", _hoisted_10, _toDisplayString(_ctx.nestedOne === menu.id ? 'expand_less' : 'expand_more'), 1)
                              ])
                            ], 8, _hoisted_8),
                            (_ctx.nestedOne === menu.id)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _createElementVNode("div", _hoisted_12, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subMenu(menu.id), (menu2, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "va-button-dropdown va-button-dropdown--normal menu",
                                        key: index
                                      }, [
                                        (_ctx.subSubMenu(menu2.id).length > 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                              _createElementVNode("button", {
                                                onClick: ($event: any) => (_ctx.nestTwoClick(menu2.id)),
                                                class: "va-button va-button--flat va-button--normal",
                                                style: {"color":"rgb(44, 130, 224)","background":"var(--va-transparent)"}
                                              }, [
                                                _createElementVNode("div", _hoisted_15, [
                                                  _createTextVNode(_toDisplayString(menu2.menu_titel) + " ", 1),
                                                  _createElementVNode("i", _hoisted_16, _toDisplayString(_ctx.nestedTwo === menu2.id ? 'expand_less' : 'expand_more'), 1)
                                                ])
                                              ], 8, _hoisted_14),
                                              (_ctx.nestedTwo === menu2.id)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                    _createElementVNode("div", _hoisted_18, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subSubMenu(menu2.id), (menu3, index) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                          class: "va-button-dropdown va-button-dropdown--small menu",
                                                          key: index
                                                        }, [
                                                          (_ctx.subSubSubMenu(menu3.id).length > 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                                _createElementVNode("button", {
                                                                  onClick: ($event: any) => (_ctx.nestThreeClick(menu3.id)),
                                                                  class: "va-button va-button--flat va-button--small",
                                                                  type: "button",
                                                                  href: "",
                                                                  target: "",
                                                                  to: "",
                                                                  replace: "false",
                                                                  "active-class": "",
                                                                  exact: "false",
                                                                  style: {"color":"rgb(44, 130, 224)","background":"var(--va-transparent)"}
                                                                }, [
                                                                  _createElementVNode("div", _hoisted_21, [
                                                                    _createTextVNode(_toDisplayString(menu3.menu_titel) + " ", 1),
                                                                    _createElementVNode("i", _hoisted_22, _toDisplayString(_ctx.nestedThree=== menu3.id ? 'expand_less' : 'expand_more'), 1)
                                                                  ])
                                                                ], 8, _hoisted_20),
                                                                (_ctx.nestedThree === menu3.id)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                                      _createElementVNode("div", _hoisted_24, [
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subSubSubMenu(menu3.id), (menu4, index) => {
                                                                          return (_openBlock(), _createElementBlock("button", {
                                                                            key: index,
                                                                            class: "va-button va-button--flat va-button--small menu",
                                                                            type: "button",
                                                                            exact: "false",
                                                                            style: {"color":"rgb(44, 130, 224)","background":"var(--va-transparent)"},
                                                                            onClick: ($event: any) => (_ctx.navigation(menu4.menu_url, _ctx.convertToSlug(menu.menu_titel), _ctx.convertToSlug(menu2.menu_titel), _ctx.convertToSlug(menu3.menu_titel)))
                                                                          }, [
                                                                            _createElementVNode("div", _hoisted_26, _toDisplayString(menu4.menu_titel), 1)
                                                                          ], 8, _hoisted_25))
                                                                        }), 128))
                                                                      ])
                                                                    ]))
                                                                  : _createCommentVNode("", true)
                                                              ]))
                                                            : (_openBlock(), _createElementBlock("button", {
                                                                key: 1,
                                                                onClick: ($event: any) => (_ctx.navigation(menu3.menu_url, _ctx.convertToSlug(_ctx.menu_titel), _ctx.convertToSlug(menu2.menu_titel))),
                                                                class: "va-button va-button--flat va-button--normal menu",
                                                                exact: "false",
                                                                style: {"color":"rgb(44, 130, 224)","background":"var(--va-transparent)"}
                                                              }, [
                                                                _createElementVNode("div", _hoisted_28, _toDisplayString(menu3.menu_titel), 1)
                                                              ], 8, _hoisted_27))
                                                        ]))
                                                      }), 128))
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : (_openBlock(), _createElementBlock("button", {
                                              key: 1,
                                              onClick: ($event: any) => (_ctx.navigation(menu2.menu_url, _ctx.convertToSlug(menu.menu_titel))),
                                              class: "va-button va-button--flat va-button--normal menu",
                                              exact: "false",
                                              style: {"color":"rgb(44, 130, 224)","background":"var(--va-transparent)"}
                                            }, [
                                              _createElementVNode("div", _hoisted_30, _toDisplayString(menu2.menu_titel), 1)
                                            ], 8, _hoisted_29))
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.navigation(menu.menu_url)),
                            class: "va-button va-button--flat va-button--normal menu",
                            type: "button",
                            style: {"color":"rgb(44, 130, 224)","background":"var(--va-transparent)"}
                          }, [
                            _createElementVNode("div", _hoisted_32, _toDisplayString(menu.menu_titel), 1)
                          ], 8, _hoisted_31))
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.openMenu)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "outside__click",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openCloseMenu()))
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}